/*
 * Tiny Scrollbar
 * http://www.baijs.nl/tinyscrollbar/
 *
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.opensource.org/licenses/gpl-2.0.php
 *
 * Date: 13 / 08 / 2012 mod 17 / 06 / 2013
 * @version 1.81 mod 0.0.5
 * @author Maarten Baijs, Igor Kuzmin (mod)
 *
 * @require wheel.listener.js
 */
;( function( $ )
{
    $.tiny = $.tiny || { };

    $.tiny.scrollbar = {
        options: {
                axis           : 'y'    // vertical or horizontal scrollbar? ( x || y || both).
            ,   wheel          : 40     // how many pixels must the mouswheel scroll at a time.
            ,   scroll         : true   // enable or disable the mousewheel.
            ,   lockscroll     : true   // return scrollwheel to browser if there is no more content.
            ,   size           : 'auto' // set the size of the scrollbar to auto or a fixed number.
            ,   sizethumb      : 'auto' // set the size of the thumb to auto or a fixed number.
            ,   sizethumb_min  : '40'   // minimal size of the thumb (if sizethumb == 'auto')
            ,   margin         : 0      // Value to subdivide from size (if size == 'auto')
            ,   invertscroll   : true   // Enable mobile invert style scrolling
            ,   callback       : null   // Callback on scroll
        }
    };

    /**
     * @usage $el.tinyscrollbar( options);
     * @usage $el.tinyscrollbar( axis, 'update' [, scroll] );
     * @usage $el.tinyscrollbar( axis, 'update', options );
     * @usage $el.tinyscrollbar( axis [, scroll] );
     * @usage $el.tinyscrollbar( 'update' [, scroll] );
     * @usage $el.tinyscrollbar( 'update', options );
     * @usage $el.tinyscrollbar( ); // Updating, if already initted, else — init.
     * @usage $el.tinyscrollbar( axis ); // Updating by axis, or initting for axis
     *
     */
    $.fn.tinyscrollbar = function( first, second, third )
    {
        var sAxis;
        var bUpdate = false;
        var oOptions = {};
        var sScroll;

        if(first == 'x' || first == 'y')
        {
            bUpdate = 1;
            sAxis = first;
            if(second === undefined)
            {
                if(this.data('tsb_'+sAxis) !== undefined) bUpdate = true;
                else oOptions = {axis: sAxis};
            }
            else
            {
                if(second == 'update')
                {
                    if(third instanceof Object) oOptions = third;
                    else sScroll = third;
                }
                else
                {
                    sScroll = second;
                 }
            }
        }
        else
        {
            sAxis = null;
            if(first == 'update')
            {
                bUpdate = 1;
                if(second instanceof Object) oOptions = second;
                else sScroll = second;
            }
            else if(first instanceof Object)
            {
                oOptions = first;
            }
        }


        if( bUpdate )
        {
            return this.tinyscrollbar_update(sAxis, sScroll, oOptions);
        }
        else
        {

            var options = $.extend( {}, $.tiny.scrollbar.options, oOptions );

            this.each( function()
            {
                if(options.axis=='y' || options.axis=='both') $( this ).data('tsb_y', new Scrollbar( $( this ), $.extend({},options,{axis:'y'}) ) );
                if(options.axis=='x' || options.axis=='both') $( this ).data('tsb_x', new Scrollbar( $( this ), $.extend({},options,{axis:'x'}) ) );

            });

            return this;

        }
    };

    $.fn.tinyscrollbar_update = function(first, second, third)
    {
        var sAxis;
        var sScroll;
        var oOptions;

        if(first == 'x' || first == 'y')
        {
            sAxis = first;
            sScroll = second;
            oOptions = third;

            if( this.data( 'tsb_'+sAxis ) !== undefined)
            {
                this.data( 'tsb_'+sAxis ).update(sScroll, oOptions);
            }

            return this;

        }
        else
        {
            sScroll = first;
            oOptions = second;

            this.tinyscrollbar_update('y', sScroll, oOptions);
            this.tinyscrollbar_update('x', sScroll, oOptions);

            return this;
        }

    };

    function Scrollbar( root, options )
    {
        var oSelf       = this
        ,   oWrapper    = root
        ,   oViewport   = { obj: $( '.viewport', root ) }
        ,   oContent    = { obj: $( '.overview', root ) }
        ,   oScrollbar  = { obj: $( '.scrollbar'+(options.axis === 'x'?'_x':''), root ) }
        ,   oTrack      = { obj: $( '.track', oScrollbar.obj ) }
        ,   oThumb      = { obj: $( '.thumb', oScrollbar.obj ) }
        ,   sAxis       = options.axis === 'x'
        ,   sDirection  = sAxis ? 'left' : 'top'
        ,   sSize       = sAxis ? 'Width' : 'Height'
        ,   iScroll     = 0
        ,   iPosition   = { start: 0, now: 0 }
        ,   iMouse      = {}
        ,   touchEvents = 'ontouchstart' in document.documentElement
        ;

        function initialize()
        {
            oSelf.update();
            setEvents();

            return oSelf;
        }

        this.update = function( sScroll, oOptionsToUpdate )
        {


            if(oOptionsToUpdate !== undefined) $.extend(options, oOptionsToUpdate);

            oViewport[ options.axis ] = oViewport.obj[0][ 'offset'+ sSize ];
            oContent[ options.axis ]  = oContent.obj[0][ 'scroll'+ sSize ];
            oContent.ratio            = oViewport[ options.axis ] / oContent[ options.axis ];
            //oContent.obj.css(options.axis, 0);

            if(1)//oContent.ratio < 1)
            {

                oTrack[ options.axis ] = options.size === 'auto' ? oViewport[ options.axis ] : options.size;
                if(options.margin) oTrack[ options.axis ] -= options.margin;

                oThumb[ options.axis ] = Math.min( oTrack[ options.axis ], Math.max( 0, ( options.sizethumb === 'auto' ? Math.max( oTrack[ options.axis ] * oContent.ratio, options.sizethumb_min ) : options.sizethumb ) ) );

                oScrollbar.ratio = ( oContent[ options.axis ] - oViewport[ options.axis ] ) / ( oTrack[ options.axis ] - oThumb[ options.axis ] );

                iScroll = ( sScroll === 'relative' && oContent.ratio <= 1 ) ? Math.min( ( oContent[ options.axis ] - oViewport[ options.axis ] ), Math.max( 0, iScroll )) : 0;
                iScroll = ( sScroll === 'bottom' && oContent.ratio <= 1 ) ? ( oContent[ options.axis ] - oViewport[ options.axis ] ) : isNaN( parseInt( sScroll, 10 ) ) ? iScroll : parseInt( sScroll, 10 );

                setSize();

            }

            oScrollbar.obj.toggleClass( 'disable', (oContent.ratio >= 1) ).toggle((oContent.ratio < 1));

        };

        function setSize()
        {
            var sCssSize = sSize.toLowerCase();

            scroll(iScroll);

            iMouse.start = oThumb.obj.offset()[ sDirection ];

            oScrollbar.obj.css( sCssSize, oTrack[ options.axis ] );
            oTrack.obj.css( sCssSize, oTrack[ options.axis ] );
            oThumb.obj.css( sCssSize, oThumb[ options.axis ] );
        }

        function setEvents()
        {
            if( ! touchEvents )
            {
                oThumb.obj.bind( 'mousedown', start );
                oTrack.obj.bind( 'mouseup', drag );
            }
            else
            {
                oViewport.obj[0].ontouchstart = function( event )
                {
                    if( 1 === event.touches.length )
                    {
                        start( event.touches[ 0 ] );
                        event.stopPropagation();
                    }
                };
            }

            //if( options.scroll && window.addEventListener )
            //{
                /****
                oWrapper[0].addEventListener( 'wheel', wheel, false );
                oWrapper[0].addEventListener( 'mousewheel', wheel, false );
                oWrapper[0].addEventListener( 'MozMousePixelScroll', function( event ){
                    event.preventDefault();
                }, false);
                ****/

                //addWheelListener(oWrapper[0], wheel, false);

            //}
            /****
            else if( options.scroll )
            {
                oWrapper[0].onmousewheel = wheel;
            }
            ***/
            $(oWrapper[0]).mousewheel(wheel_delta);
        }

        function start( event )
        {
            $( "body" ).addClass( "noSelect" );

            var oThumbDir   = parseInt( oThumb.obj.css( sDirection ), 10 );
            iMouse.start    = sAxis ? event.pageX : event.pageY;
            iPosition.start = oThumbDir == 'auto' ? 0 : oThumbDir;

            if( ! touchEvents )
            {
                $( document ).bind( 'mousemove', drag );
                $( document ).bind( 'mouseup', end );
                oThumb.obj.bind( 'mouseup', end );
            }
            else
            {
                document.ontouchmove = function( event )
                {
                    event.preventDefault();
                    drag( event.touches[ 0 ] );
                };
                document.ontouchend = end;
            }

            event.originalEvent.preventDefault();
        }

        // НЕ используется
        function wheel( event )
        {


            if( oContent.ratio < 1 )
            {
                var oEvent = event || window.event
                ,   iDelta; // = oEvent.wheelDelta ? oEvent.wheelDelta / 120 : -oEvent.detail / 3
                //;

				if(sAxis)
				{
					iDelta = oEvent.wheelDeltaX !== undefined ? oEvent.wheelDeltaX/120 : -oEvent.deltaX/3;
				}
				else
				{
					iDelta = oEvent.wheelDeltaY !== undefined ? oEvent.wheelDeltaY/120: -oEvent.deltaY/3;
				}

                iScroll -= iDelta * options.wheel;
                iScroll = Math.min( ( oContent[ options.axis ] - oViewport[ options.axis ] ), Math.max( 0, iScroll ));

                oThumb.obj.css( sDirection, iScroll / oScrollbar.ratio );
                oContent.obj.css( sDirection, -iScroll );

                if( options.lockscroll || ( iScroll !== ( oContent[ options.axis ] - oViewport[ options.axis ] ) && iScroll !== 0 ) )
                {
                    oEvent = $.event.fix( oEvent );
                    oEvent.preventDefault();
                }
            }
        }

        function wheel_delta( event, delta, deltaX, deltaY )
        {

            if( oContent.ratio < 1 )
            {
                var iDelta;

                if(sAxis)
                {
                    iDelta = -deltaX;
                }
                else
                {
                    iDelta = deltaY;
                }

                if(navigator.platform.split('Mac').length-1)
                {
                    iDelta = iDelta / 60;
                }

                //alert('1');

                iScroll -= iDelta * options.wheel;
                iScroll = Math.min( ( oContent[ options.axis ] - oViewport[ options.axis ] ), Math.max( 0, iScroll ));

                //console.log(options.axis, iDelta, options.wheel, iScroll);

                //oThumb.obj.css( sDirection, iScroll / oScrollbar.ratio );
                //oContent.obj.css( sDirection, -iScroll );
                scroll(iScroll);

                if(iScroll) return false;

            }
        }


        function drag( event )
        {
            if( oContent.ratio < 1 )
            {
                if( options.invertscroll && touchEvents )
                {
                    iPosition.now = Math.min( ( oTrack[ options.axis ] - oThumb[ options.axis ] ), Math.max( 0, ( iPosition.start + ( iMouse.start - ( sAxis ? event.pageX : event.pageY ) ))));
                }
                else
                {
                     iPosition.now = Math.min( ( oTrack[ options.axis ] - oThumb[ options.axis ] ), Math.max( 0, ( iPosition.start + ( ( sAxis ? event.pageX : event.pageY ) - iMouse.start))));
                }

                iScroll = iPosition.now * oScrollbar.ratio;
                //oContent.obj.css( sDirection, -iScroll );
                //oThumb.obj.css( sDirection, iPosition.now );
                scroll(iScroll);
            }
        }

        function scroll( iDelta )
        {
            oContent.obj.css( sDirection, -iDelta );
            oThumb.obj.css( sDirection, iDelta / oScrollbar.ratio );
            if(options.callback) options.callback(options.axis, iDelta);
        }

        function end()
        {
            $( "body" ).removeClass( "noSelect" );
            $( document ).unbind( 'mousemove', drag );
            $( document ).unbind( 'mouseup', end );
            oThumb.obj.unbind( 'mouseup', end );
            document.ontouchmove = document.ontouchend = null;
        }

        return initialize();
    }

}(jQuery));
